"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedMessageList = VirtualizedMessageList;
exports.useRowHeights = useRowHeights;
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DEFAULT_ROW_HEIGHT = 96;

// Tracks per-row measured heights for react-window's VariableSizeList, since
// message bubbles vary in height (attachments, translation sub-bubbles,
// reply-quote blocks).
function useRowHeights() {
  let defaultHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ROW_HEIGHT;
  const listRef = (0, _react.useRef)(null);
  const heightsRef = (0, _react.useRef)({});
  const getRowHeight = (0, _react.useCallback)(index => {
    var _heightsRef$current$i;
    return (_heightsRef$current$i = heightsRef.current[index]) !== null && _heightsRef$current$i !== void 0 ? _heightsRef$current$i : defaultHeight;
  }, [defaultHeight]);
  const setRowHeight = (0, _react.useCallback)((index, size) => {
    if (heightsRef.current[index] !== size) {
      var _listRef$current;
      heightsRef.current[index] = size;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.resetAfterIndex(index);
    }
  }, []);
  return {
    listRef,
    getRowHeight,
    setRowHeight
  };
}

// Headless-ish virtualized list: it owns the windowing math (react-window)
// but takes a `renderRow` render-prop for the actual bubble markup, so both
// the Bootstrap (lobees-web) and MUI (lobees-admin) presentational layers can
// use it without this package owning any markup of its own. Optional, since
// virtualization changes DOM structure that a presentational layer's existing
// CSS may assume (see plan risks) — a layer can render `messages.map(...)`
// directly instead if that's not yet been reconciled.
function VirtualizedMessageList(_ref) {
  let messages = _ref.messages,
    height = _ref.height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "100%" : _ref$width,
    _ref$estimatedRowHeig = _ref.estimatedRowHeight,
    estimatedRowHeight = _ref$estimatedRowHeig === void 0 ? DEFAULT_ROW_HEIGHT : _ref$estimatedRowHeig,
    renderRow = _ref.renderRow,
    scrollToBottomRef = _ref.scrollToBottomRef;
  const _useRowHeights = useRowHeights(estimatedRowHeight),
    listRef = _useRowHeights.listRef,
    getRowHeight = _useRowHeights.getRowHeight,
    setRowHeight = _useRowHeights.setRowHeight;
  const measureRow = (0, _react.useCallback)(index => node => {
    if (node) {
      setRowHeight(index, node.getBoundingClientRect().height);
    }
  }, [setRowHeight]);
  const Row = (0, _react.useCallback)(_ref2 => {
    let index = _ref2.index,
      style = _ref2.style;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: style,
      ref: measureRow(index),
      children: renderRow({
        index,
        message: messages[index]
      })
    });
  }, [messages, renderRow, measureRow]);
  if (scrollToBottomRef) {
    scrollToBottomRef.current = () => {
      if (messages.length > 0) {
        var _listRef$current2;
        (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollToItem(messages.length - 1, "end");
      }
    };
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.VariableSizeList, {
    ref: listRef,
    height: height,
    width: width,
    itemCount: messages.length,
    itemSize: getRowHeight,
    itemKey: index => {
      var _ref3, _messages$index$id, _messages$index, _messages$index2;
      return (_ref3 = (_messages$index$id = (_messages$index = messages[index]) === null || _messages$index === void 0 ? void 0 : _messages$index.id) !== null && _messages$index$id !== void 0 ? _messages$index$id : (_messages$index2 = messages[index]) === null || _messages$index2 === void 0 ? void 0 : _messages$index2.tempId) !== null && _ref3 !== void 0 ? _ref3 : index;
    },
    children: Row
  });
}